<div id="grievances-objectives" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h1 class="title">Objectives of the Grievance Committee</h1>
    <div class="inner-lead mt-4">
      <div class="row g-3">
        <div class="col-md-5">
          <a href="assets/pdf/grievances/Objectives-of-the-Student-Grievance-Committee.pdf" target="_blank"
            class="pdf-download-btn w-100 text-center">
            <i class="fa fa-file-pdf-o me-2"></i>View Objectives PDF
          </a>
        </div>
      </div>
    </div>
  </div>
</div>